var path = 'app/scripts/modules/google/src/serverGroup/configure/wizard/capacity/simpleCapacitySelector.component.html';
var html = "<div class=\"form-group\">\n  <div class=\"col-md-3 sm-label-right\">Number of Instances</div>\n  <help-field key=\"gce.serverGroup.capacity\"></help-field>\n  <div class=\"col-md-2\"><input type=\"number\" ng-change=\"$ctrl.setMinMax($ctrl.command.capacity.desired)\"\n                               class=\"form-control input-sm\"\n                               ng-model=\"$ctrl.command.capacity.desired\"\n                               min=\"0\"\n                               required/></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/google/src/serverGroup/configure/wizard/capacity/simpleCapacitySelector.component.html
// module id = 1348
// module chunks = 0